import * as React from "react"
import { useRecoilValue } from "recoil"
import { brandingSelector } from "../../../recoil/atoms/room"
import { CopyIcon } from "../../common/icons"
import {
  ModerationSubTitle,
  ModerationSettingsList,
  ModerationSettingsItem,
  ModerationSettingsName,
  ModerationLink
} from "./moderation.styled"
import { roomLinksSelector } from "../../../recoil/atoms/roomLinks"
import { RoomLinksProps } from "./moderation.interfaces"
import { useTranslation } from "react-i18next"
import MOLocation from "../../../util/MOLocation"

const ModerationLinks = React.memo(() => {
  const { t } = useTranslation()
  const roomStyles = useRecoilValue(brandingSelector)
  const currentUrl = MOLocation.getLocation().origin
  const { audienceHash, broadcasterHash } = useRecoilValue(roomLinksSelector)

  const roomLinks = React.useMemo<RoomLinksProps[]>(() => {
    return [
      {
        id: 10001,
        name: t("Audience"),
        url: `${currentUrl}/${audienceHash}`
      },
      {
        id: 10002,
        name: t("Broadcaster"),
        url: `${currentUrl}/${broadcasterHash}`
      }
    ]
  }, [audienceHash, broadcasterHash, currentUrl, t])

  return (
    <>
      <ModerationSubTitle
        style={{ color: roomStyles?.servicePanelElementSecondaryText }}
      >
        {t("ROOM LINKS")}
      </ModerationSubTitle>
      <ModerationSettingsList>
        {roomLinks.map((link, index) => (
          <ModerationSettingsItem key={link.id}>
            <ModerationSettingsName
              roomStyles={roomStyles}
              style={{ marginRight: index === 0 ? "1.6rem" : "0.5rem" }}
            >
              {link.name}
            </ModerationSettingsName>
            <ModerationLink
              href={link.url}
              target="_blank"
              rel="noreferrer"
              roomStyles={roomStyles}
            >
              {link.url.replace(/^https?:\/\//, "")}
            </ModerationLink>
            <CopyIcon
              textToCopy={link.url}
              textForToast={t("Link copied to clipboard")}
            />
          </ModerationSettingsItem>
        ))}
      </ModerationSettingsList>
    </>
  )
})

export default ModerationLinks
